//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import date from 'quasar/src/utils/date.js';;
var timeStamp = Date.now();
var formattedString = date.formatDate(timeStamp, "MM/DD/YYYY");
export default {
  name: "DatePickerWithInput",
  components: {},
  props: {
    value: {
      default: function _default() {
        return formattedString;
      }
    },
    customStyle: {
      default: " q-pb-none"
    },
    landscape: {
      type: Boolean
    },
    readOnly: {
      default: false
    },
    overrideReadOnly: {
      default: false
    },
    editable: {
      default: true
    },
    required: {
      default: false
    },
    rules: {
      type: Array
    },
    dense: {
      type: Boolean,
      default: true
    },
    minimal: {
      type: Boolean
    },
    label: null,
    refs: {
      type: String
    },
    options: null,
    inputStyle: {
      type: String,
      default: ""
    },
    BGColor: {
      type: String,
      default: "white"
    },
    clearable: {
      default: false
    }
  },
  data: function data() {
    return {
      originalValue: null,
      dateSelectedViaPopup: false
    };
  },
  mounted: function mounted() {
    this.originalValue = this.value;
  },
  methods: {
    selectDate: function selectDate($event) {
      this.dateSelectedViaPopup = true;
      this.$emit("input", $event);
      this.$refs.qDateProxy.hide();
      this.$refs.input.resetValidation();
    },
    handleDateInput: function handleDateInput(event) {
      if (!this.dateSelectedViaPopup) {
        this.$emit('input', event.target.value);
      }

      this.dateSelectedViaPopup = false;
    },
    validate: function validate() {
      return this.$refs.input.validate();
    },
    isRequired: function isRequired() {
      return !this.required || this.value != null || "Required";
    },
    resetDirty: function resetDirty() {
      this.originalValue = this.value;
    }
  },
  computed: {
    nativeValue: {
      get: function get() {
        if (this.value != null) {
          return date.formatDate(new Date(this.value), "MM/DD/YYYY");
        } else return "";
      },
      set: function set(v) {
        this.$emit("update:value", v);
      }
    },
    getFriendlyValue: {
      get: function get() {
        return date.formatDate(new Date(this.value), "MM/DD/YYYY");
      }
    },
    isDirty: function isDirty() {
      return this.value != "" && this.value != this.originalValue;
    }
  }
};